import React, { FC } from "react";
import LoginForm from "../molecules/LoginForm";

import AuthCard from "../atoms/AuthCard";
//Login
const LoginPage: FC = () => {
  return (
    <>
      <AuthCard title="Login" form={<LoginForm />} />
    </>
  );
};

export default LoginPage;
